import React, { useEffect, useState } from 'react';
import IJobDetails from '../../interfaces/IJobDetails';
import { JobCurrentCandidatesLoading, JobCurrentCandidatesWrapper } from './styles';
import { Typo25 } from '../Typography';

interface Props {
  job: IJobDetails;
}

export const JobCurrentCandidates = (props: Props) => {
  const { job } = props;

  const { uid } = job;

  const [currentCandidates, setCurrentCandidates] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`/api/job-data?uid=${uid}`)
      .then(res => res.json())
      .then(data => {
        setCurrentCandidates(data.currentCandidates);
        setLoaded(true);
      })
      .catch(() => {
        setCurrentCandidates(0);
        setLoaded(true);
      });
  }, [uid]);

  const renderCurrentCandidates = () => {
    if (!loaded) return <JobCurrentCandidatesLoading />;
    if (currentCandidates > 0) {
      return <>{currentCandidates} Candidates currently in process</>;
    }
    return <>No candidates in process yet. Be the first to apply!</>;
  };

  return (
    <JobCurrentCandidatesWrapper>
      <Typo25
        style={{
          marginRight: '14px',
          display: 'flex',
          gap: '4px',
          fontWeight: 700,
          color: '#1b1b1b',
          opacity: '0.4',
          textTransform: currentCandidates > 0 ? 'uppercase' : 'none',
        }}
      >
        {renderCurrentCandidates()}
      </Typo25>
    </JobCurrentCandidatesWrapper>
  );
};
